<template>
  <div id="product-list-page" class="product"
    :class="{noCategory: !productCategory.filter(x => x.id !== '').length}"
    :data-category="categoryDepth">
    <!-- product category -->
    <div v-if="productCategory.filter(x => x.id !== '').length" ref="productCategory" id="productCategory" class="category"
      :style="baseStyle">
      <div class="categoryBox" ref="category">
        <button type="button"
          v-for="cate in productCategory.filter(x => x.id !== '')"
          :key="cate.id"
          :class="{active: cate.id === category}"
          :style="cate.id === category && { ...skinStyle('productActivate', 'border-color'), ...skinStyle('productActivate', 'color'), ...skinStyle('productActivate', 'background-color', 10) }"
          @click="setCategory(cate.id)">
          {{cate.label[lang]}}
        </button>
      </div>
      <div v-if="subCategory && subCategory.length" class="subCategory">
        <button type="button"
          v-for="cate in subCategory"
          :key="cate.id"
          :class="{active: cate.id === category2}"
          :style="cate.id === category2 && { ...skinStyle('productActivate', 'border-color'), ...skinStyle('productActivate', 'color') }"
           @click="setSubCategory(cate.id)">
           <span >{{cate.label[lang]}}</span>
        </button>
      </div>
      <div v-if="subCategory2 && subCategory2.length" class="subCategory">
        <button type="button"
          v-for="cate in subCategory2"
          :key="cate.id"
          :class="{active: cate.id === category3}"
          :style="cate.id === category3 && { ...skinStyle('productActivate', 'border-color'),  ...skinStyle('productActivate', 'color') }"
           @click="setSubCategory2(cate.id)">
           <span >{{cate.label[lang]}}</span>
        </button>
      </div>
    </div>
    <!-- //product category -->
    <!-- category slider -->
    <!-- <Carousel
      v-if="categoryImage && categoryImage.length"
      :autoplay="true"
      :autoplayTimeout="3000"
      :loop="true"
      :perPage="1"
      :mouseDrag="true"
      :paginationPadding="4"
      :paginationActiveColor="'rgba(0,0,0,0.4)'"
      :paginationColor="'rgba(0,0,0,0.2)'"
      class="categoryImage">
      <Slide v-for="(slide, index) in categoryImage" :key="index" class="carouselImg">
        <img v-if="slide" :src="slide" alt="" />
      </Slide>
    </Carousel> -->
    <!-- //category slider -->
    <!-- place -->
    <div v-if="placeList && placeList.length" class="places">
      {{locale.place}}
      <select
        v-model="productPlace"
        class="input"
        @change="setPlace(productPlace)">
        <option
          v-for="(item, index) in placeList"
          :key="index"
          :value="index.toString()">
          {{item[lang]}}
        </option>
      </select>
    </div>
    <!-- //place -->
    <!-- product list -->
    <ProductList
      :lang="lang"
      :responsive="responsive"
      :list="productByCategory"
      :listType="listType"
      :loadData="loadData"
      :viewType="viewType"
      :locale="locale"
      :roomKey="roomKey"
      :place="placeList ? placeList[productPlace] : null"
      :activeSort="activeSort"
      :displaySort="displaySort"
      :sortby="sortby"
      :viewCart="viewCart"
      :setDefaultImage="setDefaultImage"
      @setViewType="changeViewType"
      @setDetail="setDetail"
      @setSortby="setSortby"
      @setViewCart="setViewCart" />
    <!-- //product list -->
    <div class="layer placeLayer" v-if="placeLayer">
      <div class="inner">
        <h2 class="layerTitle">{{locale.place_select}}</h2>
        <div class="placeList">
          <div v-for="(item, index) in placeList"
            :key="index" class="checkbox radio">
            <input type="radio" :id="`product_place_${index}`" @change="setPlace(index)">
            <label :for="`product_place_${index}`" class="btn btnWhite btnFull">{{item[lang]}}</label>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="productDetail"
      id="productDetailInfo"
      @click.stop="gotoProduct($event)">
      <div class="pageWrap">
      <Page
        :id="productDetail"
        :locale="locale"
        :lang="lang"
        :responsive="responsive"
        :translateType="translateType"
        :guestType="guestType"
        @destroy="productDetail = null" />
      </div>
    </div>
    <div v-if="responsive === 'tablet'" id="productShortcut" class="notranslate">
      <router-link
        :to="{name: 'mypage'}"
        :style="{...skinStyle('productActivate', 'border-color'), ...skinStyle('productActivate', 'background-color')}"
        class="btn btnMypage toCapitalize">
        {{ locale.mypage }}
      </router-link>
      <!-- <router-link
        :to="{name: 'cart'}"
        :style="{...skinStyle('productActivate', 'border-color'), ...skinStyle('productActivate', 'background-color')}"
        class="btn btnCart toCapitalize">
        {{ locale.cart }}
      </router-link> -->
      <button
        :style="{...skinStyle('productActivate', 'border-color'), ...skinStyle('productActivate', 'background-color')}"
        class="btn btnCart toCapitalize"
        @click.stop="viewCart = true">
        {{ locale.cart }}
        <span
          v-if="cartCount"
          class="cartCount"
          :style="{...skinStyle('productActivate', 'color')}">
          {{ cartCount }}
        </span>
      </button>
    </div>
    <div v-if="viewCart" id="floatingCart">
      <FloatingCart
        :locale="locale"
        :lang="lang"
        :isPublic="isPublic"
        :responsive="responsive"
        @close="viewCart = false" />
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import ProductList from '@/components/Product/ProductList.vue'
import Page from '@/views/Page.vue'
import FloatingCart from '@/views/Cart'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'Product',
  props: [
    'lang',
    'locale',
    'roomKey',
    'responsive',
    'translateType',
    'productId',
    'guestType',
    'isPublic'
  ],
  components: {
    Carousel,
    Slide,
    ProductList,
    Page,
    FloatingCart
  },
  computed: {
    baseStyle () {
      const baseColors = this.$store.getters['common/getPointColorsMultiple']
      const baseBg = baseColors([{ target: 'contentsBg', attr: 'background-color' }])
      const baseText = baseColors([{ target: 'contentsText', attr: 'color' }])
      return {
        ...baseBg,
        ...baseText
      }
    },
    productByCategory () {
      const items = this.productList.filter(x => validItemData(x)) // 모든 상품 데이터
      const itemsIds = items.map(x => x.id)
      const productOrder = this.productOrder
      /**
       * 순서설정 이후에 추가한 상품이
       * 가장 앞으로 쌓이고
       * 순서설정된 아이템들이 정렬
       * !!!! isSort인 경우 순서설정 무시하고 소팅
       */
      const guestType = this.guestType ? this.guestType.id : null
      const defaultGuestType = this.guestType || null
      const isSort = this.activeSort
      const sortby = this.sortby
      const locale = this.$route.params.ln
      const deduplication = isSort
        ? sorting(items, sortby, locale)
        : items.reduce(function (acc, current) {
          if (acc.findIndex(({ id }) => id === current.id) === -1) {
            acc.push(current)
          }
          return acc
        }, [])
      /**
       * 유효한 상품아이템인지 검사
       * 1. 서비스중
       * 2. 전송코드 존재
       * 3. 금액 존재
       */
      function validItemData (data) {
        return data.service && data.submitTo !== '' && regExp.replaceAllEmpty(data.info.price).length
      }
      function sorting (arr, sortby, lang) {
        const getSortKey = function (info, sortby) {
          const sortKey = sortby.split('_')[0]
          const key = sortKey.includes('name')
            ? info.name
              ? regExp.replaceAllEmpty(info.name[lang])
              : ''
            : sortKey.includes('price')
              ? parseFloat(info.price)
              : ''
          return key
        }
        const order = sortby.split('_')[1] === 'asc' ? -1 : 1
        return arr.sort(function (a, b) {
          const sortA = getSortKey(a.info, sortby)
          const sortB = getSortKey(b.info, sortby)
          return sortA > sortB ? (-1 * order) : sortA < sortB ? (1 * order) : 0
        })
      }
      // 카테고리 필터
      const listAll = sortItems(deduplication, productOrder.unCategorized).map(x => {
        const guestItem = x.guestType
          ? x.guestType[0].setDefault
            ? defaultGuestType
            : x.guestType.find(g => g.id === guestType)
          : defaultGuestType
        return {
          ...x,
          ...guestItem && {
            guestType: {
              ...guestItem,
              name: this.guestType.name
            }
          }
        }
      }).filter(x => {
        return !(x.guestType && x.guestType.hide)
      })
      const categories = this.productCategory.filter(x => x.id)
      const deepestCategories = findDeepestIds(categories, [], [], locale)
      const listByCategory = mapCategories(listAll, deepestCategories)
      const groupsByCategory = groupItemsByCategory(listByCategory)
      const formattedList = formatResult(groupsByCategory, deepestCategories).map(x => {
        const ids = x.ids && x.ids.join('|')
        return {
          ...x,
          ...ids && {
            ids: ids
          },
          items: sortItems(x.items, productOrder[x.ids[0]]) // 순서 설정은 가장 상위 카테고리로 되어있으므로 0번째 ids 요소의 순서정보를 불러온다
        }
      })
      /**
       * itemArr: 카테고리 내 상품 리스트
       * orderArr: 순서설정된 상품 리스트(정렬에 사용하므로 id만 참고한다)
       * categoryId: 순서정렬에 필요한 카테고리 id
       */
      function sortItems (itemArr = [], orderArr = []) {
        const itemIds = itemArr && itemArr.map(x => x.id)
        const ordered = orderArr.filter(x => itemIds.includes(x.id)).map(x => {
          const item = itemArr.find(item => item.id === x.id)
          return item
        })
        const orderItemIds = ordered && ordered.map(x => x.id)
        const nonOrdered = itemArr.filter(x => !orderItemIds.includes(x.id))
        return nonOrdered.concat(ordered)
      }
      // 최하위 요소 카테고리 추출하여 맵핑
      function findDeepestIds (categories, ids = [], path = [], lang) {
        const result = {}
        categories.forEach(category => {
          const label = category.label[lang]
          const currentPath = [...path, label]
          const currentIds = [...ids, category.id]
          // 자식이 있으면 재귀 호출
          if (category.children && category.children.length > 0) {
            Object.assign(result, findDeepestIds(category.children, currentIds, currentPath, lang))
          } else {
            // 자식이 없는 경우(leaf node), 결과 객체에 추가
            result[category.id] = {
              id: parseInt(category.id),
              ids: currentIds,
              label: currentPath
            }
          }
        })
        return result
      }

      // 리스트 아이템 맵핑 및 그룹핑
      function mapCategories(list, deepestIds) {
        return list.map(item => {
          const newCategories = item.category.map(cat => deepestIds[cat] && deepestIds[cat].id).filter((value, index, self) => value && self.indexOf(value) === index)
          return { ...item, category: newCategories }
        })
      }
      // 카테고리별 아이템 그룹핑
      function groupItemsByCategory (mappedList) {
        const grouped = {}
        mappedList.forEach(item => {
          item.category.forEach(cat => {
            if (!grouped[cat]) {
              grouped[cat] = []
            }
            grouped[cat].push(item)
          });
        });

        return grouped
      }
      // findLabel array
      function findValue (obj, id, key) {
        return obj[id] && obj[id][key]
      }
      // 결과 포맷팅
      function formatResult (groupedItems, deepestCategories) {
        const sortKey = Object.keys(deepestCategories).map(x => parseInt(x))
        const result = []
        function sorting (a, b) {
          return sortKey.indexOf(a.id) - sortKey.indexOf(b.id)
        }
        for (const [id, items] of Object.entries(groupedItems)) {
          result.push({ id: parseInt(id), ids: findValue(deepestCategories, id, 'ids'), label: findValue(deepestCategories, id, 'label'), items: items })
        }
        return result.sort(sorting)
      }

      return categories && categories.length
        ? formattedList
        : listAll
      // return {
      //   listAll: listAll,
      //   formattedList: formattedList
      // }
    },
    pointColors () {
      return this.$store.getters['common/getPointColors']
    },
    manageProduct () {
      return this.$store.getters['product/getManageProduct']
    },
    categoryHeight () {
      const height = this.categroy3
        ? 122
        : this.category2
          ? 84
          : 46
      return height
    },
    listType () { // uncategorized || categorized
      return this.productByCategory && this.productByCategory.find(x => x.items) ? 'categorized' : 'uncategorized'
    },
    categoryImage () {
      const id = this.category
      const id2 = this.category2
      const id3 = this.category3
      const category = this.productCategory.find(x => x.id === id)
      let result = null
      if (category) {
        if (id2 !== '') {
          if (id3 !== '') {
            if (category.children && category.children.find(c => c.id === id2) && category.children.find(c => c.id === id2).children && category.children.find(c => c.id === id2).children.find(t => t.id === id3) && category.children.find(c => c.id === id2).children.find(t => t.id === id3).image.length) {
              result = category.children.find(c => c.id === id2).children.find(t => t.id === id3).image
            } else {
              if (category.children && category.children.find(c => c.id === id2) && category.children.find(c => c.id === id2).image.length) {
                result = category.children.find(c => c.id === id2).image
              } else {
                result = category.image
              }
            }
          } else {
            if (category.children && category.children.find(c => c.id === id2) && category.children.find(c => c.id === id2).image.length) {
              result = category.children.find(c => c.id === id2).image
            } else {
              result = category.image
            }
          }
        } else {
          result = category.image
        }
      }
      return result
    },
    subCategory () {
      const category = this.category
      const list = this.productCategory
      return (list.find(x => x.id === category) && list.find(x => x.id === category).children) || []
    },
    subCategory2 () {
      const category = this.category2
      const list = this.subCategory
      return (list.find(x => x.id === category) && list.find(x => x.id === category).children) || []
    },
    categoryDepth () {
      let depth = 0
      if (this.productCategory.length) {
        depth += 1
      }
      if (this.subCategory.length) {
        depth += 1
      }
      if (this.subCategory2.length) {
        depth += 1
      }
      return depth
    },
    cartCount () {
      const list = this.$store.getters['cart/getList']()
      return list && list.length
    },
    isDutyFree () {
      return this.$store.getters['guest/isDutyfreeGuest']
    }
  },
  watch: {
    '$route' (to, from, next) {
      if ((to.params.productId !== from.params.productId)) {
        this.init(this.sortby)
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.productDetail && (
      to.name !== 'cart' &&
      to.name !== 'payment' &&
      to.name !== 'paymentStep' &&
      to.name !== 'page' &&
      to.name !== 'complete')) {
      this.productDetail = null
      next(false)
    } else {
      next()
    }
  },
  created () {
    const authentication = this.$store.state.authentication
    const ota = authentication.k || authentication.site
    const sortby = localStorage.getItem(`sortby_${ota}`)
    this.init(sortby)
    this.sortby = sortby
    window.addEventListener('beforeunload', function () {
      localStorage.removeItem(`sortby_${ota}`)
    })
  },
  beforeDestroy: function () {
    window.addEventListener('scroll', this.activeTabByScroll)
  },
  data () {
    return {
      scrollY: 0,
      scrollTo: 0,
      lastScrollTop: 0,
      isScrolling: false,
      loadData: false,
      productCategory: [],
      category: '',
      category2: '',
      category3: '',
      categoryTree: {},
      categoryPosition: [],
      viewType: '',
      productList: [],
      productOrder: [],
      placeLayer: false,
      placeList: null,
      productPlace: '',
      productDetail: null,
      activeSort: false,
      displaySort: false,
      sortby: 'created', // asc, dec, priceAsc, priceDec, created
      viewCart: false,
      pageIds: [], // 현재 연결된 페이지가 모두 유효한지?
      setDefaultImage: false
    }
  },
  methods: {
    getScrollY () {
      return this.scrollY
    },
    track (title) {
      const site = this.$store.state.authentication.site
      const routerPath = this.$route.path
      const path = `${site}${routerPath}`
      this.$gtag.pageview({
        page_path: path,
        page_title: title
      })
    },
    skinStyle (target, attr, alpha) {
      return this.pointColors(target, attr, alpha)
    },
    init (sortby) {
      this.productDetail = null
      this.$store.dispatch('submit/getSubmitCode')
      this.$store.dispatch('product/getManageProduct').then((res) => {
        this.getProduct(sortby).then(() => {
          this.setCategoryPosition() // 각 리스트그룹별 위치값 세팅(offsetTop)
          this.observeCategoryHeight() // 카테고리 뎁스에 따른 높이값 감지
          this.listScrollBar() // 현재 카테고리로 스크롤바 이동
          this.categoryScrollBar() // 카테고리 스크롤바 위치 조정
          window.addEventListener('scroll', this.activeTabByScroll)
          window.addEventListener('scrollend', () => { this.isScrolling = false })
          window.addEventListener('resize', this.setCategoryPosition)
          if (this.$route.params.category) {
            this.listScrollBar()
          }
        })
      })
    },
    changeViewType (type) {
      this.viewType = type
    },
    setDetail (data) {
      this.productDetail = data.page
      this.$route.meta.productItemId = data.detail
    },
    setSortby (data) {
      const authentication = this.$store.state.authentication
      const ota = authentication.k || authentication.site
      this.sortby = data
      localStorage.setItem(`sortby_${ota}`, data)
    },
    gotoProduct (e) {
      if (e.target === e.currentTarget) {
        this.productDetail = null
        this.$router.replace({ meta: null })
        this.$store.commit('product/setProductAvailableTime', null)
      }
    },
    async getProductVersion () {
      const productId = this.productId
      const version = await this.$store.dispatch('versionhistory/getLastVersion', { file: `product/item/${productId}.json` })
      const productData = await this.$store.dispatch('versionhistory/getIndexedDb', {
        table: 'product',
        id: productId,
        version: version || 0
      })
      if (!productData || productData === 'diffVersion') {
        const loadFile = await this.$store.dispatch('versionhistory/getFile', { file: `product/item/${productId}.json`, version: version, fileId: productId })
        if (loadFile && loadFile.data) {
          await this.$store.dispatch('product/setProductData', loadFile.data)
          this.$store.dispatch('versionhistory/setIndexedDb', {
            table: 'product',
            id: loadFile.data.id,
            version: loadFile.data.version,
            data: loadFile.data
          })
          return loadFile.data
        } else {
          const loadProduct = await this.$store.dispatch('product/getProduct', productId)
          return loadProduct
        }
      } else {
        await this.$store.dispatch('product/setProductData', productData)
        return productData
      }
    },
    priceDutyFree (price) {
      return regExp.priceDutyFree(price)
    },
    async getAllPage () {
      const res = await this.$store.dispatch('page/getAllPage')
      const ids = res && res.length && res
      if (ids) {
        this.pageIds = ids
      }
      return ids
    },
    strToNumber (str) {
      return regExp.numberOnly(str)
    },
    async getProduct (sortby) {
      const setting = await this.$store.dispatch('product/getProductSetting')
      const promotionList = setting && setting.promotion
      const productId = this.productId
      const manageList = this.manageProduct
      const categoryChildrenIds = function (arr) {
        let result = []
        const ids = function (arr) {
          arr.forEach(function (x) {
            if (x.children && x.children.length) {
              ids(x.children)
            }
            return result.push(x.data.id)
          })
          return result
        }
        return ids(arr)
      }
      await this.getAllPage()
      function setCategory (arr) {
        return arr.map(x => {
          if (!x.data) {
            x = { data: x }
          }
          if (x.children && x.children.length) {
            return {
              ...x.data,
              children: setCategory(x.children),
              childrenIds: categoryChildrenIds(x.children)
            }
          } else {
            return {
              ...x.data
            }
          }
        })
      }
      this.$store.commit('loading', true)
      return this.getProductVersion().then((res) => {
        this.loadData = true
        if (res) {
          this.track(res.title)
          // 상품 이용장소
          if (res.place && res.placeList.length) {
            this.placeList = res.placeList
            const productId = res.id
            if (localStorage && localStorage.length) {
              for (let i = 0; i < localStorage.length; i++) {
                /**
                 * 이용장소가 기존에 설정했었는지에 따라
                 * 설정 레이어를 초기에 보여주거나 감춤
                 */
                const storage = localStorage.key(i)
                if (storage.includes('place_') && storage.includes(productId)) {
                  this.placeLayer = false
                  this.productPlace = localStorage.getItem(storage)
                  break
                } else {
                  this.placeLayer = true
                }
              }
            }
          }
          const category = (res && res.category && res.category.filter(x => {
            return (x.id && x.id !== '') || (x.data && x.data.id !== '')
          })) || []
          this.activeSort = res.activeSort
          this.displaySort = res.displaySort
          this.sortby = sortby || res.sortby
          this.setDefaultImage = res.setDefaultImage
          this.viewType = res.viewType || 'grid'
          this.productCategory = setCategory(category)
          this.category = this.$route.params.category
            ? parseInt(this.$route.params.category)
            : this.productCategory.length
              ? this.productCategory[0].id
              : ''
          this.category2 = this.subCategory && this.subCategory[0] ? this.subCategory[0].id : ''
          this.category3 = this.subCategory2 && this.subCategory2[0] ? this.subCategory2[0].id : ''
          this.productList = res.items ? res.items.map(x => {
            const promotionInfo = function (id) { // 프로모션 커스텀 적용 맵핑
              const item = promotionList && promotionList.find(x => x.id === id)
              return item && !item.default
                ? {
                  promotionCustom: !item.default,
                  promotionSize: item.size,
                  promotionIcon: item.icon
                }
                : null
            }
            // 금액 숫자로 표기
            if (x.info.price) {
              x.info.price = this.strToNumber(x.info.price)
            }
            // 페이지가 연결되어 있는 상품인 경우 해당 페이지가 유효한지 체크
            if (x.link.type === 'page' && x.link.pageId && (this.pageIds && !this.pageIds.includes(x.link.pageId))) {
              x.link.pageId = ''
            }
            // 관리상품이나 더이상 해당 관리상품이 존재하지 않는 경우
            if (!(x.manage && x.manageInfo && manageList.find(p => p.pid === x.manageInfo.pId))) {
              delete x.manageInfo
            }
            // 이용가능시간 단일설정 -> 다중설정 맵핑
            const available = {
              ...x.available,
              set: x.available.set.map(t => {
                const time = t.time || (t.timeFrom && t.timeTo && {
                  time: [
                    {
                      from: t.timeFrom,
                      to: t.timeTo
                    }
                  ]
                })
                return {
                  ...t,
                  ...time
                }
              })
            }
            // 카테고리 단일설정 -> 다중설정 맵핑 (info.category에서 category로 이동)
            let category = x.category || []
            if (!x.category) {
              if (x.info.category) {
                category.push(x.info.category)
              }
              if (x.info.category2) {
                category.push(x.info.category2)
              }
              if (x.info.category3) {
                category.push(x.info.category3)
              }
            }
            return {
              ...x,
              available: available,
              category: category,
              info: {
                ...x.info,
                ...x.info.promotion && x.info.promotionCustom && promotionInfo(x.info.promotion)
              }
            }
          }) : []
          this.productOrder = (res.order && Array.isArray(res.order) ? this.setProductOrder(res.order, category) : res.order) || []
        } else {
          alert(this.locale.alert_system_error)
        }
        this.$store.commit('loading', false)
      })
    },
    setProductOrder (orderArr, category) {
      const list = orderArr
      if (category && category.length) {
        const result = {}
        for (let i = 0; i < category.length; i++) {
          const cate = category[i]
          const cateId = cate.data.id
          result[cateId] = list.filter(x => {
            return x.category
              ? x.category.filter(c => cate.data.id === c || (cate.childrenIds && cate.childrenIds.includes(c))).length > 0
              : x.info.category
                ? cate.childrenIds && cate.childrenIds.includes(x.info.category)
                : false
          })
        }
        return result
      }
    },
    setCategory (categoryId) {
      const ln = this.$route.params.ln
      this.category = categoryId
      this.category2 = this.subCategory && this.subCategory[0] && this.subCategory[0].id
      this.category3 = this.subCategory2 && this.subCategory2[0] && this.subCategory2[0].id
      this.$router.replace({
        name: 'productCategory',
        params: {
          productId: this.productId,
          category: categoryId,
          ln: ln
        }
      })
      this.listScrollBar()
      this.categoryScrollBar()
    },
    setSubCategory (categoryId) {
      this.category2 = categoryId
      this.category3 = this.subCategory2 && this.subCategory2[0] && this.subCategory2[0].id
      this.listScrollBar()
    },
    setSubCategory2 (categoryId) {
      this.category3 = categoryId
      this.listScrollBar()
    },
    setPlace (idx) {
      const index = parseInt(idx)
      const place = this.placeList[index] || null
      const placeName = place ? place[this.lang] : ''
      setTimeout(() => {
        alert(`${this.locale.place}: ${placeName}\n${this.locale.message_place_reselect}`)
      }, 300)
      setTimeout(() => {
        this.placeLayer = false
      }, 600)
      this.productPlace = idx
      localStorage.setItem(`place_${this.productId}`, index)
    },
    getCategoryName (categoryId) {
      const lang = this.lang
      const categories = getCategories(this.productCategory)
      function getCategories (arr) {
        let result = []
        for (let i = 0; i < arr.length; i++) {
          const item = arr[i]
          result.push(item)
          if (item.children && item.children.length) {
            for (let j = 0; j < item.children.length; j++) {
              const child = item.children[j]
              result.push(child)
              if (child.children && child.children.length) {
                for (let k = 0; k < child.children.length; k++) {
                  const tail = child.children[k]
                  result.push(tail)
                }
              }
            }
          }
        }
        return result
      }
      return categories.find(x => x.id === categoryId).label[lang] || 'category'
    },
    categoryScrollBar () {
      const container = document.getElementById('container')
      const category = this.$refs.category
      const activeCategory = category && category.querySelector('.active')
      if (activeCategory && container) {
        const offset = activeCategory.offsetLeft
        const width = activeCategory.offsetWidth / 2
        const screen = container.clientWidth / 2
        category.scrollLeft = offset - (screen - width)
      }
    },
    setCategoryPosition () {
      let result = []
      const elements = document.querySelectorAll('[data-group]')
      const listEl = document.getElementById('product-list-page')
      const listHeight = (listEl && listEl.clientHeight) || 0
      const categoryEl = document.getElementById('productCategory')
      const categoryHeight = (categoryEl && categoryEl.offsetHeight) || 0
      elements.forEach(element => {
        // data-group_item 속성 값
        const id = element.getAttribute('data-group')
        const groupIds = element.getAttribute('data-group_item')
        const ids = groupIds && groupIds.split('|')
        const top = element.offsetTop
        const bottom = top + element.offsetHeight
        result.push({
          id: parseInt(id),
          top: top,
          height: element.offsetHeight,
          ids: ids.map(x => parseInt(x))
        })
      })
      this.categoryPosition = result.map((x, i) => {
        const isFirst = i === 0
        const isLast = i === result.length - 1
        return {
          ...x,
          originTop: x.top,
          isFirst: isFirst,
          isLast: isLast,
          top: x.top,
          bottom: x.top + x.height
        }
      })
    },
    observeCategoryHeight() {
      const resizeObserver = new ResizeObserver(() => {
        if (this.isScrolling) {
          this.listScrollBar()
        }
      })
      const categoryEl = document.getElementById('productCategory')
      if (categoryEl) {
        resizeObserver.observe(categoryEl)
      }
    },
    listScrollBar () {
      const headerEl = document.getElementById('header')
      const headerHeight = this.responsive !== 'tablet' && (headerEl && headerEl.offsetHeight) || 0
      const categoryEl = document.getElementById('productCategory')
      const categoryHeight = (categoryEl && categoryEl.offsetHeight) || 0
      const uiHeight = headerHeight + categoryHeight
      const categoryId = this.category3 || this.category2 || this.category
      if (categoryId) {
        const findPosition = document.querySelector(`[data-group="${categoryId}"]`)
        const offsetTop = findPosition
          ? findPosition.offsetTop === 0
            ? 0
            : findPosition.offsetTop - uiHeight
          : 0
        this.isScrolling = true
        this.scrollTo = offsetTop
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        })
      }
    },
    activeTabByScroll (e) {
      const scrollTop = window.scrollY
      const headerEl = document.getElementById('header')
      const headerHeight = this.responsive !== 'tablet' && (headerEl && headerEl.offsetHeight) || 0
      const categoryEl = document.getElementById('productCategory')
      const categoryHeight = (categoryEl && categoryEl.offsetHeight) || 0
      const uiHeight = headerHeight + categoryHeight
      const scrollDirection = scrollTop > this.lastScrollTop ? 'down' : 'up'
      const targetList = this.categoryPosition.filter((x, i) => {
        return scrollDirection === 'down'
          ? scrollTop >= document.body.scrollHeight - document.body.clientHeight - 30
            ? x.isLast
            : x.top - uiHeight <= scrollTop && x.top - uiHeight + 50 >= scrollTop
          : scrollTop <= 100
            ? x.isFirst
            : x.top - uiHeight - 100 <= scrollTop && x.top - uiHeight + 50 >= scrollTop
      })
      const target = scrollDirection === 'down' ? targetList[0] : targetList.reverse()[0]
      function positionArr () {
        let result = []
        document.querySelectorAll('[data-group]').forEach(element => {
          // data-group_item 속성 값
          const id = element.getAttribute('data-group')
          const groupIds = element.getAttribute('data-group_item')
          const ids = groupIds && groupIds.split('|')
          const top = element.offsetTop
          const bottom = top + element.offsetHeight
          result.push({
            id: parseInt(id),
            top: top,
            height: element.offsetHeight,
            ids: ids.map(x => parseInt(x))
          })
        })
        return result
      }
      if (target && !this.isScrolling){
        const ids = target.ids
        for (let i = 0; i < ids.length; i++) {
          const category = `category${i === 0 ? '' : (i + 1)}`
          this[category] = ids[i]
        }
      }
      this.scrollY = scrollTop
      this.lastScrollTop = scrollTop
    },
    getManageProduct () {
      return this.$store.dispatch('product/getManageProduct')
    },
    setViewCart (view) {
      this.viewCart = view
    }
  }
}
</script>

<style lang="scss" scoped>
.placeLayer {
  .layerTitle {
    padding-right: 0;
    text-align: center;
  }
  .inner {
    align-items: center;
    justify-content: center;
    color: $color-white;
    background: none;
  }
  .placeList {
    width: 100%;
    max-height: 100%;
    border-radius: 4px;
    background-color: $color-white;
    overflow: auto;
    .btn {
      padding: 1em 1em 1em 40px;
      &:before {
        top: 50%;
        left: 1em;
        margin-top: -10px;
      }
    }
    .checkbox {
      display: block;
      margin: 0;
      & + .checkbox .btn {
        border-top: none;
      }
    }
  }
}
.places {
  height: 34px;
  margin-bottom: -34px;
  padding-top: 15px;
  padding-left: 15px;
  font-size: 0.85em;
  .input {
    max-width: 50%;
    width: auto;
    min-height: 0;
    height: 34px;
    padding: 0.4em;
  }
}
.category {
  position: fixed;
  top: 50px;
  left: 0;
  right: 0;
  overflow: hidden;
  border-bottom: 1px solid rgba(0,0,0,0.15);
  background-color: $color-white;
  box-shadow: 0 0 5px rgba(0,0,0,0.15);
  z-index: 8;
  .categoryBox {
    overflow-x: auto;
    white-space: nowrap;
  }
  button {
    position: relative;
    height: 60px;
    padding: 0 30px;
    color: color-mix(in srgb, currentColor 70%, transparent);
    .ico {
      display: block;
      width: 24px;
      margin: 0 auto;
      opacity: 0.5;
    }
    &.active {
      font-weight: 700;
      color: inherit;
      border-color: $color-primary;
      .ico {
        opacity: 1;
      }
      &:after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        border-top: 4px solid $color-white;
        border-top-color: inherit;
      }
    }
  }
  .subCategory {
    overflow: auto;
    font-size: 0.85em;
    white-space: nowrap;
    border-top: 1px solid rgba(0,0,0,0.15);
    box-shadow: inset 0 0 5px rgba(0,0,0,0.1);
    button {
      height: 32px;
      padding-left: 15px;
      padding-right: 15px;
      border-bottom: 1px solid transparent;
      .ico {
        display: inline-block;
        width: 20px;
        margin-right: 4px;
        margin-bottom: 0;
      }
      &.active {
        border-color: $color-primary;
        &:after {
          display: none;
        }
        span:after {
          content: "";
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          height: 1px;
          border-top: 1px solid $color-primary;
          border-color: inherit;
        }
      }
    }
  }
  &.fixed {
    position: fixed;
    button {
      .ico {
        display: inline-block;
        width: 24px;
        margin-bottom: 0;
      }
    }
    .subCategory {
      button {
        .ico {
          width: 20px;
        }
      }
    }
  }
}

.product {
  &[data-category="1"] {
    padding-top: 60px;
  }
  &[data-category="2"] {
    padding-top: 94px; //94px;
  }
  &[data-category="3"] {
    padding-top: 126px; //126px;
  }
  &.noCategory {
    padding-top: 0;
  }
}
.roomKey .category {
  top: 90px;
}
.scrollDown .roomKey .category {
  top: 50px;
  transition-delay: 0.8s;
}
@media screen and (min-width: 768px) {
  .category {
    top: 0 !important;
    left: 80px;
  }
}
@media screen and (min-width: 800px) {
  .category {
    left: 180px;
  }
}
@media screen and (min-width: 1024px) {
  .category {
    left: 240px;
  }
  .places {
    height: 49px;
    margin-bottom: -49px;
    padding-top: 30px;
    padding-left: 30px;
  }
}
.noFrame .category {
  top: 0 !important;
  left: 0 !important;
}
</style>
